import React,{useState,useEffect} from 'react'
import './Banner.css'
import axios from './axios'
import requests from './Requests'
function Banner() {
    const[movie,setMovie]=useState([])

    useEffect(()=>{
        async function fetchData(){
            const request = await axios.get(requests.fetchTrending);
            setMovie(request.data.results[Math.floor(Math.random()*request.data.results.length -1 )]
            );
            return request;
        }
        fetchData()
    },[]);
    console.log(movie)

    function truncate(string,n){
        return string?.length>n?string.substr(0,n-1)+'...':string;
    }
    return (
        <div className="banner"
            style={{
                backgroundSize: "cover",
        
                backgroundImage:`url("https://image.tmdb.org/t/p/original/${movie?.backdrop_path}")`,
                backgroundPosition:'center center'
            }}

            >
            
            <div className="banner__contents">
               { <h1 className="banner__title">{movie?.title||movie?.name||movie?.original_name}</h1> }
                {/* <h1 className="banner__title">Title</h1> */}
                <div className="banner__buttons">
                    <button className="banner__button">Play</button>
                    <button className="banner__button">My List</button>
                </div>
                {<h1 className="banner__desc">{truncate(movie?.overview,150)} </h1> }
                {/* <h1 className="banner__desc">Description </h1> */}


            </div>
            <div className="banner__fadebottom"/>
        </div>
    )
}

export default Banner
